
const digest = 'd7e1e05b9c04e83d2e8c53c57ecb9c7b8779a9c3d12a3fcb53b48874a8a45ded';
const classes = {"placeholder":"_placeholder_1ilj8_1"};
const css = `._placeholder_1ilj8_1 {
  width: 100%;
  aspect-ratio: 16/9;
  background: #5491eb;
  background: linear-gradient(122deg, rgb(84, 145, 235) 0%, rgb(15, 58, 122) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  